import filterTypeEnum from "../../../../components/Filter/enumerations/filterTypeEnum";
import agentStatusEnum from "./agentStatusEnum";
import {
  filterKeyAgentData,
  filterKeyBasicInfo,
  filterKeyMemberBetAmountData,
  filterKeyMemberData,
  filterKeyUserData,
} from "./filterKeyEnum";
import { default as memberDataBetAmountLevelEnum } from "./memberDataBetAmountLevelEnum";
import memberDataRoleEnum from "./memberDataRoleEnum";

const filterSetupBasicInfo = {
  //FILTER TYPE:
  // 1: with quick search
  // 2: only dropdowns
  filter_type: 1,
  //Filter type 1 will have special quick search on top
  //fill out the data here
  quick_search: {
    title: "normal.account",
    data_index: filterKeyBasicInfo.ACCOUNT,
  },
  filters: [
    {
      title: "normal.uid",
      data_index: filterKeyBasicInfo.ACCOUNT_ID,
      /**
       * Currently have 3 types
       * SELECT: dropdown
       * DATE_TIME_RANGE: select start date and end date
       * INPUT: typing the value
       */
      type: filterTypeEnum.INPUT,
      required: false,
    },
    {
      title: "subordinate.userBasicInfo.isAgent",
      data_index: filterKeyBasicInfo.ROLE,
      type: filterTypeEnum.SELECT,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: agentStatusEnum,
    },
    {
      title: "normal.registrationTime",
      type: filterTypeEnum.DATE_TIME_RANGE,
      //IF type=DATE_TIME_RANGE, data_index will eat 2 values [start_date, end_date]
      data_index: [filterKeyBasicInfo.REGISTER_START_DATE, filterKeyBasicInfo.REGISTER_END_DATE],
      required: false,
      precision: "second",
    },
    {
      title: "subordinate.userBasicInfo.reviewedTime",
      type: filterTypeEnum.DATE_TIME_RANGE,
      data_index: [
        filterKeyBasicInfo.AGENT_REVIEWED_START_DATE,
        filterKeyBasicInfo.AGENT_REVIEWED_END_DATE,
      ],
      required: false,
      precision: "second",
    },
  ],
};

const filterSetupUserData = {
  filter_type: 1,
  quick_search: {
    title: "normal.account",
    data_index: filterKeyUserData.ACCOUNT,
  },
  filters: [
    {
      title: "normal.uid",
      data_index: filterKeyUserData.ACCOUNT_ID,
      type: filterTypeEnum.INPUT,
      required: false,
    },
    {
      title: "normal.dataTime",
      data_index: [filterKeyUserData.SETTLED_START_DATE, filterKeyUserData.SETTLED_END_DATE],
      type: filterTypeEnum.DATE_TIME_RANGE,
      required: true,
      precision: "second",
    },
  ],
};

const filterSetupAgentData = {
  filter_type: 1,
  quick_search: {
    title: "normal.account",
    data_index: filterKeyAgentData.ACCOUNT,
  },
  filters: [
    {
      title: "mobile.subordinate.inviteCode",
      data_index: filterKeyAgentData.INVITE_CODE,
      type: filterTypeEnum.INPUT,
      required: false,
    },
    {
      title: "normal.dataTime",
      data_index: [filterKeyAgentData.START_DATE, filterKeyAgentData.END_DATE],
      type: filterTypeEnum.DATE_TIME_RANGE,
      required: true,
      precision: "second",
    },
  ],
};

const filterSetupMemberData = {
  filter_type: 1,
  quick_search: {
    title: "memberData.agentAccount",
    data_index: filterKeyMemberData.ACCOUNT,
  },
  filters: [
    {
      title: "normal.dataTime",
      data_index: [filterKeyMemberData.SETTLED_START_DATE, filterKeyMemberData.SETTLED_END_DATE],
      type: filterTypeEnum.DATE_TIME_RANGE,
      required: true,
      precision: "second",
      maxMonthInterval: 6,
    },
    {
      title: "agentData.subordinateLevelSearch",
      data_index: filterKeyMemberData.LEVEL,
      type: filterTypeEnum.SELECT,
      required: true,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: memberDataBetAmountLevelEnum,
    },
    {
      title: "subordinate.userBasicInfo.isAgent",
      data_index: filterKeyMemberData.IS_AGENT,
      type: filterTypeEnum.SELECT,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: memberDataRoleEnum,
    },
  ],
};

const filterSetupMemberBetAmountData = {
  filter_type: 1,
  quick_search: {
    title: "memberData.agentAccount",
    data_index: filterKeyMemberBetAmountData.ACCOUNT,
  },
  filters: [
    {
      title: "normal.agent.account",
      data_index: filterKeyMemberBetAmountData.AGENT_ACCOUNT,
      /**
       * Currently have 3 types
       * SELECT: dropdown
       * DATE_TIME_RANGE: select start date and end date
       * INPUT: typing the value
       */
      type: filterTypeEnum.INPUT,
      required: false,
    },
    {
      title: "normal.dataTime",
      data_index: [filterKeyMemberData.SETTLED_START_DATE, filterKeyMemberData.SETTLED_END_DATE],
      type: filterTypeEnum.DATE_TIME_RANGE,
      required: true,
      precision: "second",
      maxMonthInterval: 6,
    },

    {
      title: "agentData.subordinateLevelSearch",
      data_index: filterKeyMemberData.LEVEL,
      type: filterTypeEnum.SELECT,
      required: true,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: memberDataBetAmountLevelEnum,
    },
    {
      title: "subordinate.userBasicInfo.isAgent",
      data_index: filterKeyMemberData.IS_AGENT,
      type: filterTypeEnum.SELECT,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: memberDataRoleEnum,
    },
  ],
};

export {
  filterSetupAgentData,
  filterSetupBasicInfo,
  filterSetupMemberBetAmountData,
  filterSetupMemberData,
  filterSetupUserData,
};
